import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import SincronizacionesLayer from "../../components/comprobantes/SincronizacionesLayer"

const Sincronizacion = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Sincronización" />

        {/* RoleAccessLayer */}
        <SincronizacionesLayer/>

      </MasterLayout>

    </>
  );
};

export default Sincronizacion; 
